<template>
    <div class="warpper padding-sm">
        <div class="page-title line-height">积分管理</div>
        <div class="basic-info active margin-top-sm">
            <el-form ref="ruleForm" :model="ruleForm" :rules="rules"
                     class="flex flex-direction justify-center" label-width="auto">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="新会员登录（次/分）" prop="login_num">
                            <el-input-number v-model="ruleForm.login_num" controls :min="0" placeholder="请输入分值" size="small">
                            </el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="会员续费（次/分）" prop="user_renewal">
                            <el-input-number v-model="ruleForm.user_renewal" controls :min="0" placeholder="请输入分值" size="small">
                            </el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="报名参加会内活动（次/分）" prop="to_activity">
                            <el-input-number v-model="ruleForm.to_activity" controls :min="0" placeholder="请输入分值" size="small">
                            </el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="会内活动签到（次/分）" prop="sign_activity">
                            <el-input-number v-model="ruleForm.sign_activity" controls :min="0" placeholder="请输入分值" size="small">
                            </el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="查看通知（条/分）" prop="show_iterative">
                            <el-input-number v-model="ruleForm.show_iterative" controls :min="0" placeholder="请输入分值" size="small">
                            </el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="反馈通知（条/分）" prop="back_iterative">
                            <el-input-number v-model="ruleForm.back_iterative" controls :min="0" placeholder="请输入分值" size="small">
                            </el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="查看组织动态（条/分）" prop="show_org">
                            <el-input-number v-model="ruleForm.show_org" controls :min="0" placeholder="请输入分值" size="small">
                            </el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="申请服务（条/分）" prop="apply_service">
                            <el-input-number v-model="ruleForm.apply_service" controls :min="0" placeholder="请输入分值" size="small">
                            </el-input-number>
                            <div><span class="text-red">*注</span>：申请服务审核通过后可获得积分</div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-button :loading="loading" class="input-form-btn self-center" @click="submitForm('ruleForm')">保存配置
            </el-button>
        </div>
    </div>
</template>

<script>

import {getConfigurationDetail, setIntegral} from "../../../../api/organiz";

export default {
    name: "integral_setting",
    data() {
        return {
            ruleForm: {
                login_num:0,// 登陆积分
                user_renewal:0,// 会员续费积分
                to_activity:0,// 报名参加会内活动
                sign_activity:0,// 会内活动签到
                show_iterative:0,// 查看通知
                back_iterative:0,// 反馈通知
                show_org:0,// 查看组织动态
                apply_service :0,//申请服务
            },
            rules: {
                login_num: [
                    {required: true, message: "请输入新会员登录积分", trigger: "blur"}
                ],
                user_renewal: [
                    {required: true, message: '请输入会员续费积分', trigger: 'blur'}
                ],
                to_activity: [
                    {required: true, message: '请输入报名参加会内活动积分', trigger: 'blur'}
                ],
                sign_activity: [
                    {required: true, message: "请输入会内活动签到积分", trigger: "blur"}
                ],
                show_iterative: [
                    {required: true, message: '请输入查看通知积分', trigger: 'blur'}
                ],
                back_iterative: [
                    {required: true, message: '请输入反馈通知积分', trigger: 'blur'}
                ],
                show_org: [
                    {required: true, message: '请输入查看组织动态积分', trigger: 'blur'}
                ],
                apply_service: [
                    {required: true, message: '请输入申请服务积分', trigger: 'blur'}
                ]

            },
            loading: false
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    created() {
        this.$emit('setIndex', [9, 0], '积分设置')
        this.init()
    },
    components: {},
    methods: {
        async init() {
            let _data = await getConfigurationDetail(this.user.mid)
            if (_data.data) {
                this.ruleForm.login_num = _data.data.login_num
                this.ruleForm.user_renewal = _data.data.user_renewal
                this.ruleForm.to_activity = _data.data.to_activity
                this.ruleForm.sign_activity = _data.data.sign_activity
                this.ruleForm.show_iterative = _data.data.show_iterative
                this.ruleForm.back_iterative = _data.data.back_iterative
                this.ruleForm.show_org = _data.data.show_org
                this.ruleForm.apply_service = _data.data.apply_service
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitInfo()
                }
            });
        },
        async submitInfo() {
            this.loading = true
            let _data = await setIntegral(this.ruleForm.login_num,this.ruleForm.user_renewal,this.ruleForm.to_activity,
                this.ruleForm.sign_activity,this.ruleForm.show_iterative,this.ruleForm.back_iterative,
                this.ruleForm.show_org,this.ruleForm.apply_service)
            this.loading = false
            if (_data.status === 200) {
                this.$message.success('设置成功')
            }
        },
    },
    filters: {},
    watch: {},
}
</script>

<style lang="scss" scoped>
.warpper {
    padding: 20px 30px;
    background-color: #ffffff;
    border-radius: 10px;

    .basic-info {
        display: flex;
        flex-direction: column;
        background-color: #ffffff;
        border-radius: 10px;
        padding: 40px 63px 20px 0px;

        &.active {
            //border: solid 1px #e4e4e4;
            padding: 40px 63px 20px 30px;
        }

        .pay-money {
            font-size: 16px;
            color: #999999;
            text-align: center;
            margin: 20px 0;

            span {
                font-size: 24px;
                color: #ed4444;
            }
        }

        .el-select {
            width: 100%;
        }
    }

    .input-form-btn {
        width: 200px;
        height: 40px;
        background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
        linear-gradient(#0a2240, #0a2240);
        background-blend-mode: normal, normal;
        border-radius: 20px;
        font-size: 16px;
        color: #ffffff;
        margin: 30px auto 0;
    }
}
</style>
